import React from "react";
import Header from "../components/Layout/header";
import Footer from "../components/Layout/footer";

export default function Blog() {
  return (
    <div>
      <Header />
 
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-gray-800">Launching Soon</h1>
          <p className="mt-4 text-lg text-gray-600">
            We're putting the final touches on something amazing. Stay tuned for
            updates!
          </p>
          <button className="mt-6 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">
            Get Notified
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
